import HttpService from './http.service';

export default {
  fetchEvents,
  fetchEvent,
  createEvent,
  updateEvent,
  deleteEvent,
  fetchEventRegistrations,
  createEventRegistration,
  updateEventRegistration,
  deleteEventRegistration,
  fetchWhatsAppConfigs,
  createWhatsAppConfig,
  updateWhatsAppConfig,
  deleteWhatsAppConfig,
  sendWhatsAppNotification,
  generateEventShareUrl,
  fetchEventPublic,
};

async function fetchEvents(params = {}) {
  return HttpService.get('/event', { params });
}

async function fetchEvent(id) {
  return HttpService.get(`/event/${id}`);
}

async function fetchEventPublic(id) {
  return HttpService.get(`/public/events/${id}`);
}

async function createEvent(eventData) {
  return HttpService.post('/event', eventData);
}

async function updateEvent(id, eventData) {
  return HttpService.put(`/event/${id}`, eventData);
}

async function deleteEvent(id) {
  return HttpService.delete(`/event/${id}`);
}

async function generateEventShareUrl(id) {
  return HttpService.post(`/event/${id}/share-url`);
}

async function fetchEventRegistrations(eventId, params = {}) {
  return HttpService.get('/event-registrations', { event_id: eventId, ...params });
}

async function createEventRegistration(registrationData) {
  return HttpService.post('/public/event-registrations', registrationData);
}

async function updateEventRegistration(_, registrationId, registrationData) {
  return HttpService.put(`/event-registrations/${registrationId}`, registrationData);
}

async function deleteEventRegistration(_, registrationId) {
  return HttpService.delete(`/event-registrations/${registrationId}`);
}

async function fetchWhatsAppConfigs(params = {}) {
  return HttpService.get('/whatsapp-configs', { params });
}

async function createWhatsAppConfig(configData) {
  return HttpService.post('/whatsapp-configs', configData);
}

async function updateWhatsAppConfig(id, configData) {
  return HttpService.put(`/whatsapp-configs/${id}`, configData);
}

async function deleteWhatsAppConfig(id) {
  return HttpService.delete(`/whatsapp-configs/${id}`);
}

async function sendWhatsAppNotification(notificationData) {
  return HttpService.post('/whatsapp-notifications', notificationData);
}
